import styled from 'styled-components';

import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

export const FeeTable = styled.div`
    opacity: ${(props) => (props.$isLock ? '0.3' : null)};
    pointer-events: ${(props) => (props.$isLock ? 'none' : null)};
    filter: ${(props) => (props.$isLock ? 'blur(1px)' : null)};
`;
export const FeeTableSeparator = styled.div`
    align-self: unset;
    flex-grow: 1;
    background-color: ${promoColors.gray20};
    height: 1px;
    margin-bottom: 5px;
    margin-left: 8px;
    margin-right: 8px;
    min-width: 10px;
`;
export const FeeTableRow = styled.a`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    white-space: nowrap;
    cursor: ${(props) => (props.$cursorPointer ? 'pointer' : null)};
    margin-bottom: 16px;

    ${FeeTableSeparator} {
        display: none;
    }

    ${promoMedia.mobile375} {
        flex-direction: row;
        align-items: flex-end;

        ${FeeTableSeparator} {
            display: flex;
        }
    }

    ${promoMedia.retina375} {
        flex-direction: row;
        align-items: flex-end;

        ${FeeTableSeparator} {
            display: flex;
        }
    }

    &:last-child {
        margin-bottom: 0;
    }

    &[tabindex] {
        &:focus-visible {
            background-color: ${promoColors.gray5};
            outline: 1px dashed ${promoColors.gray80};
        }
    }
`;
export const FeeTableRightBlock = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: ${(props) => (props.$noShrink ? '0' : null)};
    overflow: hidden;
    max-width: 100%;
`;
